
<form #f="ngForm">

	<div class="form-group row">
		<label class="col-lg-2 offset-lg-3 col-form-label">{{ 'FE.ORDER.FORMS.LABELS.TOREQUESTDISTRIBUTOR.TOREQUESTDISTRIBUTOR' | localize }}<i class="text-danger">*</i></label>

		<div class="col-lg-4 kt-margin-b-10-tablet-and-mobile">
			<mat-select class="form-control"
						placeholder="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.TOREQUESTDISTRIBUTOR.TOREQUESTDISTRIBUTOR' | localize }}"
						[(ngModel)]="selectedDistributor"
						name="cmbDistributor"
						#cmbDistributor="ngModel"
						(selectionChange)="onChangeDistributor()"
						(click)="onClickLocation()"
						required>
				<mat-option>
					<!--Combo serach kısmı-->

					<ngx-mat-select-search [formControl]="addressSearchFilter"
										   placeholderLabel="{{ 'FE.ORDER.FORMS.PLACEHOLDERS.TOREQUESTDISTRIBUTOR.SEARCHDISTRIBUTOR' | localize }}"
										   noEntriesFoundLabel=""
										   >

					</ngx-mat-select-search>
					<!--Combo serach kısmı-->
				</mat-option>

				<mat-option *ngIf="isLocationNotFound">{{ 'FE.ORDER.FORMS.COMBOBOX.COMMON.NOTFOUND' | localize }}' | localize }}"</mat-option>
				<!--<mat-option>{{ 'FE.ORDER.FORMS.PLACEHOLDERS.TOREQUESTDISTRIBUTOR.TOREQUESTDISTRIBUTOR' | local }}</mat-option>-->
				<mat-option *ngIf="addressSearchFilter.value?.length < 3 && 0 < addressSearchFilter.value?.length">{{ 'FE.ORDER.FORMS.PLACEHOLDERS.COMMON.MINLETTER' | localize }}</mat-option>
				<mat-option *ngFor="let distributor of (distributors | async)" [value]="distributor">
					{{distributor.name}}
				</mat-option>

			
			</mat-select>

			
			<mat-error *ngIf="cmbDistributor.hasError('required')">{{ 'FE.REQUIREDFIELDS.COMMON.REQUIRED' | localize }}</mat-error>

			<!--<span *ngIf="showIsRequiredMessage" class="help-block" style="color: tomato;">Bu Alan Boş Bırakılamaz</span>-->
		</div>
	</div>

</form>
